export default {
  modalShowing: false,
  modalContent: undefined,
  errorStats: [],
  errorExceptionTypes: {},
  errorStatisticsKpis: {
    errorsByDate: [],
    errorsByCustomer: [],
    errorsByType: [],
    errorsByMostCommon: [],
    errorsByForms: [],
  },
  errorKpisLoading: false,
  errorStatisticsLoading: false,
  errorTab: "statistics",
};
